import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';
import { cn } from '@shared/utils/utils';

export function ChatbyInfoPanel() {
  const { t } = useTranslation('integrationsModule');
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="mt-3" data-testid="chatby-info-panel">
      <p className="text-xs leading-relaxed text-muted-foreground">{t('chatbyInfo.summary')}</p>

      <button
        type="button"
        onClick={() => setIsExpanded((prev) => !prev)}
        className="mt-1.5 inline-flex items-center gap-1 text-xs text-muted-foreground transition-colors hover:text-foreground"
        aria-expanded={isExpanded}
        data-testid="chatby-info-toggle"
      >
        {t('chatbyInfo.moreInfo')}
        <ChevronDown className={cn('h-3 w-3 transition-transform', isExpanded && 'rotate-180')} />
      </button>

      {isExpanded && (
        <div className="mt-3 space-y-3 border-t border-border/60 pt-3">
          <div>
            <p className="text-xs font-medium text-foreground">{t('chatbyInfo.whatIs.title')}</p>
            <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{t('chatbyInfo.whatIs.description')}</p>
          </div>

          <div>
            <p className="text-xs font-medium text-foreground">{t('chatbyInfo.integration.title')}</p>
            <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
              {t('chatbyInfo.integration.description')}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
